<ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
    <ng-container [ngSwitch]="!!child.command">
        <ng-template [ngSwitchCase]="false">
            <li *ngIf="child.visible === false ? false : true" [routerLink] = "!child.disabled ? child.routerLink : null"
                routerLinkActive="active-menuitem" class="tw-flex-wrap"
                [routerLinkActiveOptions]="child.routerLinkActiveOptions || {}" [class]="child.badgeStyleClass">

                <ng-container *ngTemplateOutlet="liContent; context: {$implicit: child, index: i}"></ng-container>
            </li>
        </ng-template>

        <ng-template [ngSwitchCase]="true">
            <li *ngIf="child.visible === false ? false : true" routerLinkActive="active-menuitem"
                [routerLinkActiveOptions]="child.routerLinkActiveOptions || {}" [class]="child.badgeStyleClass"
                class="tw-flex-wrap">
                <ng-container *ngTemplateOutlet="liContent; context: {$implicit: child, index: i}"></ng-container>
            </li>
        </ng-template>

    </ng-container>

</ng-template>


<ng-template #liContent let-child let-index="index">

    <ng-container *ngIf="child.isSeparator; else defaultMenuItemTemplate">
        <div class="tw-flex tw-flex-100 tw-justify-center tw-items-center tw-my-[5px]"
            style="border-bottom: 2px solid #e8e8e8;">
        </div>
    </ng-container>

    <ng-template #defaultMenuItemTemplate>
        <ng-container *ngIf="child.component; else standardItem">
            <ng-container [appLazy]="child.component"
                [appLazyData]="{menuItem: child, parentComponent: this, index}"></ng-container>
        </ng-container>

        <ng-template #standardItem>
            <app-menu-item [parameters]="{menuItem: child, parentComponent: this, index: index}"></app-menu-item>
        </ng-template>
    </ng-template>
</ng-template>
